"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _toLower = _interopRequireDefault(require("lodash/toLower"));
var _excluded = ["keyword", "autoEscape", "caseSensitive", "highlightClassName", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _default = exports["default"] = function _default(_ref) {
  var keyword = _ref.keyword,
    _ref$autoEscape = _ref.autoEscape,
    autoEscape = _ref$autoEscape === void 0 ? true : _ref$autoEscape,
    _ref$caseSensitive = _ref.caseSensitive,
    caseSensitive = _ref$caseSensitive === void 0 ? false : _ref$caseSensitive,
    _ref$highlightClassNa = _ref.highlightClassName,
    highlightClassName = _ref$highlightClassNa === void 0 ? '' : _ref$highlightClassNa,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (typeof children === 'string') {
    var res = !keyword ? children : strongKeyword(keyword, children, {
      caseSensitive: caseSensitive,
      autoEscape: autoEscape,
      highlightClassName: highlightClassName
    });
    return /*#__PURE__*/_react["default"].createElement("div", props, res);
  } else {
    return children ? /*#__PURE__*/_react["default"].cloneElement(children, props) : '';
  }
};
function strongKeyword(keyword, original, props) {
  var caseSensitive = props.caseSensitive,
    autoEscape = props.autoEscape,
    highlightClassName = props.highlightClassName;
  var mode = 'g' + (caseSensitive ? '' : 'i');
  var keywordRegx = new RegExp(autoEscape ? "(".concat(keyword.replace(/(\W)/g, '\\$1'), ")") : keyword, mode);
  return original.replace(keywordRegx, '||$1||').split('||').map(function (chunk, index) {
    return (0, _toLower["default"])(chunk) === (0, _toLower["default"])(keyword) ? /*#__PURE__*/_react["default"].createElement("span", {
      className: highlightClassName,
      key: index
    }, chunk) : /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: index
    }, chunk);
  });
}
//# sourceMappingURL=index.js.map